<ng-container *transloco="let t; read: 'microphone-permission-warning'">
  <p-messages *ngIf="showBanner$ | async" severity="warn" [closable]="false" [enableService]="false">
    <ng-template pTemplate>
      <div class="microphone-permission-warning">
        <span class="microphone-permission-warning__text">{{ t('promptMessage') }}</span>
        <button
          class="microphone-permission-warning__action"
          pButton
          pRipple
          type="button"
          [label]="t('enableButton')"
          [loading]="isRequesting$ | async"
          (click)="enableNotificationSounds()"
        ></button>
      </div>
    </ng-template>
  </p-messages>
</ng-container>
